import { Button, Dialog, Text } from '@/ui'

export const AccountDownloadDialog = () => {
  return (
    <Dialog>
      <Dialog.Content>
        <Dialog.Title>Account Download</Dialog.Title>

        <Dialog.Description>
          <Text>
            Your account information is being prepared and should be available
            shortly. Once ready for download, you will receive an email
            notification with a link to download your information.
          </Text>
        </Dialog.Description>

        <Dialog.Footer>
          <Dialog.Close asChild>
            <Button>Close</Button>
          </Dialog.Close>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog>
  )
}
